// hooks/useCartData.ts
import { useSelector } from 'react-redux'
import { RootState } from '../../.../../../../store/store'
import { selectCurrentCluster } from '../../../../store/slices/currentClusterSlice'
import { selectCurrentUser } from '../../../../store/slices/currentUserSlice'
import { selectSaleItemList } from '../../../../store/slices/saleItemListSlice'
import { selectStoreList } from '../../../../store/slices/storeListSlice'

export const useCartData = () => {
  const currentCluster = useSelector(selectCurrentCluster)
  const cart = useSelector((state: RootState) => state.cart)
  const saleItemList = useSelector(selectSaleItemList)
  const storeList = useSelector(selectStoreList)
  const currentUser = useSelector(selectCurrentUser)

  return {
    currentCluster,
    cart,
    saleItemList,
    storeList,
    currentUser,
  }
}
